// src/App.js
import React from "react";
import { Routes, Route } from "react-router-dom";

import TopNav from "./components/TopNav";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import CookieConsent from "./components/CookieConsent"
import Contact from "./pages/Contact";
import Pricing from "./pages/Pricing";
import Privacy from "./pages/Privacy";
import Automation from "./services/Automation";
import Bookkeeping from "./services/Bookkeeping";
import CustomApps from "./services/CustomApp";
import Dashboards from "./services/Dashboards";
import DataCleanup from "./services/DataCleanup";
import ItOpsSupport from "./services/ItSupport";
import Spreadsheets from "./services/Spreadsheets";
import GoogleSheetsExpert from "./services/GoogleSheetsExpert"
import ExcelExpert from "./services/ExcelExpert"
import Websites from "./services/Websites";
import ScrollToTop from "./components/ScrollToTop"
import AnalyticsListener from "./components/AnalyticsListener";
import SeoService from "./services/SeoService";

export default function App() {
  return (
    <>
      <TopNav />
      <CookieConsent />
      <AnalyticsListener />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/services/automation" element={<Automation />} />
        <Route path="/services/bookkeeping" element={<Bookkeeping />} />
        <Route path="/services/custom-apps" element={<CustomApps />} />
        <Route path="/services/dashboards" element={<Dashboards />} />
        <Route path="/services/data-cleanup" element={<DataCleanup />} />
        <Route path ="/services/google-sheets-expert" element={<GoogleSheetsExpert />} />
        <Route path ="/services/excel-expert" element={<ExcelExpert />} />
        <Route path="/services/it-support" element={<ItOpsSupport />} />
        <Route path="/services/seo" element={<SeoService />} />
        <Route path="/services/spreadsheets" element={<Spreadsheets />} />
        <Route path="/services/websites" element={<Websites />} />

        {/* <Route path="/about" element={<About />} /> */}
      </Routes>
      <Footer />
    </>
  );
}